import {
  Line
} from 'vue-chartjs'

export default {
  extends: Line,
  store: ['colorMode'],
  props: {
    dataset: Object
  },
  watch: {
    dataset: {
      handler: function (newValue, oldValue) {
        console.log('fired dataset')
        this.setGraph(newValue)
      },
      deep: true
    },
    colorMode: {
      handler: function (newValue) {
        console.log('fired colormode')
        this.setGraph()
      },
      deep: true
    }
  },
  data () {
    return {
      options: {
        'legend': {
          'display': false
        },
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          yAxes: [{
            id: 'left-y-axis',
            type: 'linear',
            position: 'left',
            ticks: {
              'beginAtZero': false,
              'display': false
            },
            'gridLines': {
              'color': 'transparent',
              'display': false
            },
            'scaleLabel': {
              'display': false
            }
          }],
          xAxes: [{
            ticks: {
              'beginAtZero': false,
              'display': false
            },
            'gridLines': {
              'color': 'transparent',
              'display': false
            }
          }]
        },
        'elements': {
          'line': {
            'lineTension': 0,
            'borderWidth': 2
          },
          'point': {
            'radius': 1.5,
            'pointHoverRadius': 5,
            'pointHitRadius': 20
          },
          'arc': {
            'borderWidth': 4
          }
        }
      }
    }
  },
  methods: {
    setGraph (newData) {
      this.dataset = newData || this.dataset
      if (this.dataset.datasets) {
        if (this.colorMode === 'darkmode') {
          this.dataset.datasets[0].borderColor = '#fff'
        } else {
          this.dataset.datasets[0].borderColor = '#3D4852'
        }
      }

      this.renderChart(this.dataset, this.options)
    }
  },
  mounted () {
    // Overwriting base render method with actual data.
    // if (this.colorMode === 'darkmode') {
    //   this.dataset.datasets[0].borderColor = '#fff'
    // } else {
    //   this.dataset.datasets[0].borderColor = '#3D4852'
    // }
    // this.renderChart(this.dataset, this.options)
    this.setGraph()
  }
}



// WEBPACK FOOTER //
// ./src/components/modules/LineChart.js